import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "project-page-view"
}
const _hoisted_2 = { class: "url-bar" }
const _hoisted_3 = { class: "url-bar-flex" }
const _hoisted_4 = { class: "url-container" }
const _hoisted_5 = { class: "url-item" }
const _hoisted_6 = { class: "url-text" }
const _hoisted_7 = { class: "hero-wrapper" }
const _hoisted_8 = { class: "hero-content" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "brand-text"
}
const _hoisted_11 = { class: "headline" }
const _hoisted_12 = { class: "description" }
const _hoisted_13 = {
  key: 0,
  class: "buttons-row"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "btn-label" }
const _hoisted_16 = {
  key: 1,
  class: "buttons-row"
}
const _hoisted_17 = { class: "action-btn" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "action-btn" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "action-btn" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "modal-card" }
const _hoisted_24 = { class: "modal-body" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "modal-footer" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "spinner-small"
}
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "modal-card" }
const _hoisted_31 = { class: "modal-body" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = {
  key: 0,
  class: "logo-preview-wrap"
}
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "file-btn-group" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = { class: "modal-footer" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "spinner-small"
}
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "modal-card" }
const _hoisted_44 = { class: "modal-body" }
const _hoisted_45 = { class: "buttons-form" }
const _hoisted_46 = { class: "button-inputs" }
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = ["onUpdate:modelValue"]
const _hoisted_49 = { class: "modal-footer" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  key: 0,
  class: "spinner-small"
}
const _hoisted_52 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.isLandSubdivision)
    ? (_openBlock(), _createBlock($setup["LandSubdivisionProjectPageEditor"], { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[10] || (_cache[10] = _createElementVNode("svg", {
              class: "link-icon",
              xmlns: "http://www.w3.org/2000/svg",
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }),
              _createElementVNode("path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" })
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "url-label" }, "PAGE URL", -1)),
                _createElementVNode("span", _hoisted_6, _toDisplayString($setup.fullUrl), 1),
                _createElementVNode("button", {
                  class: "copy-btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleCopy($setup.fullUrl)))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass($setup.copied ? 'text-green' : 'text-blue')
                  }, _toDisplayString($setup.copied ? "Copied!" : "Copy"), 3)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "hero-bg",
            style: _normalizeStyle($setup.heroBgStyle)
          }, [...(_cache[11] || (_cache[11] = [
            _createElementVNode("div", { class: "hero-overlay" }, null, -1)
          ]))], 4),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "change-bg-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openModal('hero')))
            }, [...(_cache[12] || (_cache[12] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "white",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("rect", {
                  x: "3",
                  y: "3",
                  width: "18",
                  height: "18",
                  rx: "2",
                  ry: "2"
                }),
                _createElementVNode("circle", {
                  cx: "8.5",
                  cy: "8.5",
                  r: "1.5"
                }),
                _createElementVNode("polyline", { points: "21 15 16 10 5 21" })
              ], -1),
              _createElementVNode("span", null, "Change Background", -1)
            ]))]),
            _createElementVNode("div", {
              class: "content-block",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openModal('content')))
            }, [
              _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"pencil-badge\" data-v-e7c5fbb6><div class=\"pencil-circle\" data-v-e7c5fbb6><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-e7c5fbb6><path d=\"M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7\" data-v-e7c5fbb6></path><path d=\"M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z\" data-v-e7c5fbb6></path></svg></div></div>", 1)),
              ($setup.pageData.residentialContent?.logoImageUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "logo-img",
                    src: $setup.pageData.residentialContent.logoImageUrl,
                    alt: "Logo"
                  }, null, 8, _hoisted_9))
                : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString($setup.pageData.residentialContent?.brandText || "Your Brand"), 1)),
              _createElementVNode("h1", _hoisted_11, _toDisplayString($setup.pageData.residentialContent?.headline || "Your Headline Here"), 1),
              _createElementVNode("p", _hoisted_12, _toDisplayString($setup.pageData.residentialContent?.description || "Add a description for your project."), 1)
            ]),
            _createElementVNode("div", {
              class: "buttons-block",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.openModal('buttons')))
            }, [
              _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"pencil-badge\" data-v-e7c5fbb6><div class=\"pencil-circle\" data-v-e7c5fbb6><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-e7c5fbb6><path d=\"M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7\" data-v-e7c5fbb6></path><path d=\"M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z\" data-v-e7c5fbb6></path></svg></div></div>", 1)),
              ($setup.visibleButtons.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visibleButtons, (btn, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "action-btn"
                      }, [
                        _createElementVNode("span", {
                          class: "btn-icon",
                          innerHTML: $setup.getButtonIcon(btn.destination)
                        }, null, 8, _hoisted_14),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(btn.label), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", {
                        class: "btn-icon",
                        innerHTML: $setup.getButtonIcon('home')
                      }, null, 8, _hoisted_18),
                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "btn-label" }, "Browse Home Designs", -1))
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", {
                        class: "btn-icon",
                        innerHTML: $setup.getButtonIcon('map')
                      }, null, 8, _hoisted_20),
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "btn-label" }, "Explore Map", -1))
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", {
                        class: "btn-icon",
                        innerHTML: $setup.getButtonIcon('document')
                      }, null, 8, _hoisted_22),
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "btn-label" }, "View Documents", -1))
                    ])
                  ]))
            ])
          ])
        ]),
        ($setup.activeModal === 'hero')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal-backdrop",
              onClick: _withModifiers($setup.closeModal, ["self"])
            }, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", { class: "modal-header" }, [
                  _cache[18] || (_cache[18] = _createElementVNode("span", null, "Edit Hero Image", -1)),
                  _createElementVNode("button", {
                    class: "modal-close",
                    onClick: $setup.closeModal
                  }, "✕")
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _cache[20] || (_cache[20] = _createElementVNode("label", null, "Background Image", -1)),
                    _createElementVNode("input", {
                      class: "file-input-hidden",
                      type: "file",
                      accept: "image/*",
                      ref: "heroFileRef",
                      onChange: $setup.onHeroFileChange
                    }, null, 544),
                    _createElementVNode("button", {
                      class: "custom-file-btn",
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.heroFileRef?.click()))
                    }, [
                      _cache[19] || (_cache[19] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                        _createElementVNode("polyline", { points: "17 8 12 3 7 8" }),
                        _createElementVNode("line", {
                          x1: "12",
                          y1: "3",
                          x2: "12",
                          y2: "15"
                        })
                      ], -1)),
                      _createElementVNode("span", null, _toDisplayString($setup.heroFileRef?.files?.[0]?.name || "Choose File"), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("button", {
                    class: "btn-cancel",
                    onClick: $setup.closeModal
                  }, "Cancel"),
                  _createElementVNode("button", {
                    class: "btn-save",
                    onClick: $setup.saveHero,
                    disabled: $setup.saving
                  }, [
                    ($setup.saving)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                      : _createCommentVNode("", true),
                    (!$setup.saving)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Save"))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_27)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.activeModal === 'content')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "modal-backdrop",
              onClick: _withModifiers($setup.closeModal, ["self"])
            }, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", { class: "modal-header" }, [
                  _cache[21] || (_cache[21] = _createElementVNode("span", null, "Edit Content", -1)),
                  _createElementVNode("button", {
                    class: "modal-close",
                    onClick: $setup.closeModal
                  }, "✕")
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _cache[24] || (_cache[24] = _createElementVNode("label", null, "Logo Image", -1)),
                    ($setup.logoPreview || $setup.pageData.residentialContent?.logoImageUrl)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("img", {
                            src: $setup.logoPreview || $setup.pageData.residentialContent?.logoImageUrl || '',
                            alt: "Logo preview"
                          }, null, 8, _hoisted_34)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("input", {
                        class: "file-input-hidden",
                        type: "file",
                        accept: "image/*",
                        ref: "logoFileRef",
                        onChange: $setup.onLogoFileChange
                      }, null, 544),
                      _createElementVNode("button", {
                        class: "custom-file-btn",
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.logoFileRef?.click()))
                      }, [
                        _cache[22] || (_cache[22] = _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                          _createElementVNode("polyline", { points: "17 8 12 3 7 8" }),
                          _createElementVNode("line", {
                            x1: "12",
                            y1: "3",
                            x2: "12",
                            y2: "15"
                          })
                        ], -1)),
                        _createElementVNode("span", null, _toDisplayString($setup.logoFileRef?.files?.[0]?.name || "Choose File"), 1)
                      ]),
                      ($setup.logoPreview || $setup.pageData.residentialContent?.logoImageUrl)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "remove-logo-btn",
                            type: "button",
                            onClick: $setup.removeLogo
                          }, [...(_cache[23] || (_cache[23] = [
                            _createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-e7c5fbb6><polyline points=\"3 6 5 6 21 6\" data-v-e7c5fbb6></polyline><path d=\"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2\" data-v-e7c5fbb6></path><line x1=\"10\" y1=\"11\" x2=\"10\" y2=\"17\" data-v-e7c5fbb6></line><line x1=\"14\" y1=\"11\" x2=\"14\" y2=\"17\" data-v-e7c5fbb6></line></svg><span data-v-e7c5fbb6>Remove</span>", 2)
                          ]))]))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[25] || (_cache[25] = _createElementVNode("p", { class: "hint" }, "If uploaded, the logo image will display instead of the text below.", -1))
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _cache[26] || (_cache[26] = _createElementVNode("label", null, "Logo / Brand Text", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "text-input",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.brandText) = $event)),
                      type: "text",
                      placeholder: "e.g. Vista Living"
                    }, null, 512), [
                      [_vModelText, $setup.form.brandText]
                    ]),
                    _cache[27] || (_cache[27] = _createElementVNode("p", { class: "hint" }, "Used when no logo image is uploaded.", -1))
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _cache[28] || (_cache[28] = _createElementVNode("label", null, "Headline", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "text-input",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.headline) = $event)),
                      type: "text",
                      placeholder: "e.g. Make Your Next Move Your Best One Yet"
                    }, null, 512), [
                      [_vModelText, $setup.form.headline]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _cache[29] || (_cache[29] = _createElementVNode("label", null, "Description", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      class: "text-input",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form.description) = $event)),
                      placeholder: "A short description of your project",
                      rows: "4"
                    }, null, 512), [
                      [_vModelText, $setup.form.description]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("button", {
                    class: "btn-cancel",
                    onClick: $setup.closeModal
                  }, "Cancel"),
                  _createElementVNode("button", {
                    class: "btn-save",
                    onClick: $setup.saveContent,
                    disabled: $setup.saving
                  }, [
                    ($setup.saving)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41))
                      : _createCommentVNode("", true),
                    (!$setup.saving)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, "Save"))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_40)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.activeModal === 'buttons')
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "modal-backdrop",
              onClick: _withModifiers($setup.closeModal, ["self"])
            }, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", { class: "modal-header" }, [
                  _cache[30] || (_cache[30] = _createElementVNode("span", null, "Edit Action Buttons", -1)),
                  _createElementVNode("button", {
                    class: "modal-close",
                    onClick: $setup.closeModal
                  }, "✕")
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formButtons, (btn, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "button-row",
                        key: i
                      }, [
                        _createElementVNode("label", null, "Button " + _toDisplayString(i + 1), 1),
                        _createElementVNode("div", _hoisted_46, [
                          _withDirectives(_createElementVNode("input", {
                            class: "text-input",
                            "onUpdate:modelValue": ($event: any) => ((btn.label) = $event),
                            type: "text",
                            placeholder: "Button label"
                          }, null, 8, _hoisted_47), [
                            [_vModelText, btn.label]
                          ]),
                          _withDirectives(_createElementVNode("select", {
                            class: "select-input",
                            "onUpdate:modelValue": ($event: any) => ((btn.destination) = $event)
                          }, [...(_cache[31] || (_cache[31] = [
                            _createElementVNode("option", { value: "home" }, "Home", -1),
                            _createElementVNode("option", { value: "map" }, "Map", -1),
                            _createElementVNode("option", { value: "document" }, "Document", -1)
                          ]))], 8, _hoisted_48), [
                            [_vModelSelect, btn.destination]
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("button", {
                    class: "btn-cancel",
                    onClick: $setup.closeModal
                  }, "Cancel"),
                  _createElementVNode("button", {
                    class: "btn-save",
                    onClick: $setup.saveButtons,
                    disabled: $setup.saving
                  }, [
                    ($setup.saving)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51))
                      : _createCommentVNode("", true),
                    (!$setup.saving)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_52, "Save"))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_50)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}